import React, { useEffect, useState } from 'react'
import PageTitle from '../../adminComponents/PageTitle'
import { Button, CircularProgress, Grid } from '@mui/material'
import { useNavigate, useParams } from 'react-router-dom'
import RHFTextField from '../../components/controls/RHFTextField'
import { useForm } from 'react-hook-form'
import Supabase from '../../backend/client'
import { errorToaster, successToaster } from '../../util/toaster'
import MaskLoader from '../../components/MaskLoader'
import { yupResolver } from '@hookform/resolvers/yup'
import { object, string } from 'yup'
import CustomFormLabel from '../../components/common/CustomFormLabel'
import { BLOG_CATEGORY, Bucket_Uri } from '../../shared/constant'
import RHFAutoSelect from '../../components/controls/RHFAutoSelect'
import RHFEditor from '../../components/controls/RHFEditor'

const ManageBlog = (
    {
        mode
    }
) => {
    const [loader, setLoader] = useState(false);
    const {blogId} = useParams();
    const [imgUri, setImgUri] = useState('');

    const schema = object({
        title: string().required().label('Title').nullable(),
        description: string().required().label('Description').nullable(),
        author: string().required().label('Author').nullable(),
        pulishdate: string().required().label('Pulished date').nullable(),
        category: string().required().label('Category').nullable(),
    })

    const {
        handleSubmit,
        formState: {errors},
        control,
        setValue
    } = useForm({
        resolver: yupResolver(schema),
    })

    
    let isError = false;
    let errorMessage = '';

    let isCategoryErr
  
    if(errors && Object?.keys(errors)?.includes('cover')){
      isError=true
      errorMessage = errors['cover']?.message
    }

    const getblogDetails = async () => {
        setLoader(true)
        const { data, error } = await Supabase.from('blogs').select('*').eq('id', blogId);
            if(error){
                errorToaster("Error while fetching blog")
            }
            if(data?.length){
                setValue('title', data[0]?.title)
                setValue('description', data[0]?.description)
                setValue('pulishdate', data[0]?.published_at)
                setValue('author', data[0]?.author)
                setValue('category', data[0]?.category)
                setImgUri(data[0]?.cover)
            }
            setLoader(false)
    }

    useEffect(() => {
        if(mode === 'Update' && blogId){
            getblogDetails();
        }
    },[])

    const navigate = useNavigate()

    const onSubmit = async (data) => {
        setLoader(true)
        const fileName = `cover_${Date.now()}.png`
        const {data: response, error} = await Supabase?.storage?.from('images').upload(fileName, data?.cover)
        if(error){
            errorToaster("Error while uploading Image")
            return 
        }
        const { data: insertData, error: insertError } = await Supabase
            .from('blogs')
            .insert([
                { title: data?.title, description: data?.description, cover: `${Bucket_Uri}/${fileName}`, author: data?.author, published_at: data?.pulishdate },
            ])
            .select()
        if(insertError){
            errorToaster("Error while inserting blog")
            return 
        }
        if(insertData){
            successToaster("Blog added successfully.")
            navigate('/admin/blogs')
        }
        setLoader(false)
    }

    const onUpdate = async (data) => {
        const fileName = `cover_${Date.now()}.png`;
        const paytload = {
            title: data?.title, 
            description: data?.description, 
            // cover: `https://pxquoyexibwwbzitcljc.supabase.co/storage/v1/object/public/images/${fileName}`, 
            author: data?.author, 
            published_at: data?.pulishdate,
            category: data?.category
        }
        setLoader(true)
        if(data?.cover){
            const {data: response, error} = await Supabase?.storage?.from('images').upload(fileName, data?.cover)
            if(error){
                errorToaster("Error while uploading Image")
                return 
            }
            paytload.cover =  `https://pxquoyexibwwbzitcljc.supabase.co/storage/v1/object/public/images/${fileName}`
        }
       
        const { data: updateData, error: updateError } = await Supabase
        .from('blogs')
        .update( paytload)
        .eq('id', blogId)
        .select()
        if(updateError){
            errorToaster("Error while inserting blog")
            return 
        }
        if(updateData){
            successToaster("Blog added successfully.")
            navigate('/admin/blogs')
        }
        setLoader(false)
    }

  return (
    <div>
        <div className='flex justify-between items-center' >
            <PageTitle title={`${mode} Blog`} />
            <Button 
                variant='contained' 
                disabled={loader} 
                onClick={() => navigate(-1)} 
                sx={{
                    backgroundColor: "#737477",
                    borderColor: "#0161fc",
                    borderRadius: 10
                }}
            >
                { loader ? <CircularProgress size="1rem" color='info' /> : '' } &lt;  &nbsp; Back
            </Button>
        </div>
        <Grid container p={5} spacing={2} >
            <Grid item sm={6}>
                <CustomFormLabel htmlFor='title' >
                    Title 
                </CustomFormLabel>
                <RHFTextField 
                            name="title"
                            id="title"
                            type="text"
                            fullWidth
                            placeholder="Enter Title"
                            className="mt-[10px] px-[10px] xs:py-[5px] md:py-[10px] w-full text-[12px] text-[#7A86A1] border-[1px] border-[#7A86A1] rounded-lg "
                            isControlled={true}
                            control={control}
                            errorObj={errors}
                       />
            </Grid>
            <Grid item sm={6} >
                <CustomFormLabel htmlFor='author' >
                    Author 
                </CustomFormLabel>
                <RHFTextField 
                    isControlled={true}
                    control={control}
                    errorObj={errors}
                    name="author"
                    id="author"
                    className="mt-[10px] px-[10px] xs:py-[5px] md:py-[10px] w-full text-[12px] text-[#7A86A1] border-[1px] border-[#7A86A1] rounded-lg "
                    placeholder="Enter Author Name"
                />
            </Grid>
            <Grid item sm={6} >
                <CustomFormLabel htmlFor='pulishdate' >
                    Pulish Date 
                </CustomFormLabel>
                <RHFTextField 
                    type="date"
                    isControlled={true}
                    control={control}
                    errorObj={errors}
                    name="pulishdate"
                    id="pulishdate"
                    className="mt-[10px] px-[10px] xs:py-[5px] md:py-[10px] w-full text-[12px] text-[#7A86A1] border-[1px] border-[#7A86A1] rounded-lg "
                    placeholder="Enter Publish date"
                />
            </Grid>

            <Grid item sm={6} >
                <CustomFormLabel htmlFor='category' >
                    Category
                </CustomFormLabel>
               <RHFAutoSelect 
                    options={BLOG_CATEGORY}
                    errorObj={errors}
                    name="category"
                    id="category"
                    control={control}
                    className="mt-[10px] px-[10px] xs:py-[5px] md:py-[10px] w-full text-[12px] text-[#7A86A1] border-[1px] border-[#7A86A1] rounded-lg "
                    placeholder="Select Category"
               />
                {/* <RHFTextField 
                    type="date"
                    isControlled={true}
                    control={control}
                    errorObj={errors}
                    name="pulishdate"
                    id="pulishdate"
                    className="mt-[10px] px-[10px] xs:py-[5px] md:py-[10px] w-full text-[12px] text-[#7A86A1] border-[1px] border-[#7A86A1] rounded-lg "
                    placeholder="Enter Publish date"
                /> */}
            </Grid>

            <Grid item sm={6} >
                <CustomFormLabel htmlFor='cover' >
                    Cover Image
                </CustomFormLabel>
                <input 
                    type="file"
                    name="cover"
                    id="cover"
                    accept='image/*'
                    className="mt-[10px] px-[10px] xs:py-[5px] md:py-[10px] w-full text-[12px] text-[#7A86A1] border-[1px] border-[#7A86A1] rounded-lg "
                    onChange={(e) => {
                        if(e?.target?.files?.length){
                            setValue('cover',e?.target?.files[0] )
                        }
                    }}
                />
                 {
                  isError ? <p className='text-[10px] pt-[2px] text-[red]' >{errorMessage}</p> : ""
                }
            </Grid>
            <Grid item sm={12} >
                <CustomFormLabel htmlFor='title' >
                    Description
                </CustomFormLabel>
                <RHFEditor 
                    type="text"
                    isControlled={true}
                    control={control}
                    errorObj={errors}
                    name="description"
                    id="description"
                    // className="mt-[10px] px-[10px] xs:py-[5px] md:py-[10px] w-full text-[12px] text-[#7A86A1] border-[1px] border-[#7A86A1] rounded-lg "
                    placeholder="Enter Description"
                />
            </Grid>
            {
                mode === 'Update' ? 
                    <Grid item sm={6} >
                        <CustomFormLabel htmlFor='' >
                            Image
                        </CustomFormLabel>
                        <img 
                            src={imgUri}
                            width={200}
                            height={200}
                        />
                    </Grid>
                :''
            }
            <Grid item sm={12} >
                <Button 
                    variant='contained' d
                    isabled={loader} 
                    onClick={handleSubmit( mode === 'Update' ? onUpdate : onSubmit)} 
                    sx={{
                        backgroundColor: "#0161fc",
                        borderColor: "#0161fc",
                        borderRadius: 10
                    }}
                >
                     { loader ? <CircularProgress size="1rem" color='info' /> : '' } &nbsp; Submit
                </Button>
            </Grid>
        </Grid>
    </div>
  )
}

export default ManageBlog